/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react'
import { faFloppyDisk, faRedo, faSync, faUndo, faXmark } from '@fortawesome/free-solid-svg-icons'
import { MapContainer, Polygon, Marker, TileLayer, useMap } from 'react-leaflet'
import { Button, Col, Drawer, Form, Row } from 'antd'
import * as turf from '@turf/turf'
import L from 'leaflet'

//STYLES
import { CardDados, Container } from './styles'

//APP
import { useAccess } from '../../../../../context/useAccess'
import { optionsMap } from '../../../../../services/Afins'
import { geralKmlPolygon } from '../../../../../Components/gerarKml'
import { postTalhaoCultivavel, putTalhaoCultivavel } from '../../../../../services/TalhaoSafra'
import { postTalhao, putTalhao } from '../../../../../services/Talhao'

//COMPONENT
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../../../../utils/alert'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { TitleH3 } from '../../../../../Components/CustomUi/titleH3'
import Input from '../../../../../Components/CustomUi/input'



// Ajusta visão da camera Leaflet sem dar reset no zoom a cada alteração de estado parent
const ZoomToPolygonBounds = ({ coords }: { coords: L.LatLngTuple[] }) => {
  const map = useMap()
  const initialized = React.useRef(false)

  useEffect(() => {
    if (!initialized.current && coords && coords.length > 0) {
      try {
        const bounds = L.latLngBounds(coords)
        map.fitBounds(bounds, { maxZoom: 20 })
        initialized.current = true
      } catch (e) { }
    }
  }, [map, coords])
  return null
}

interface DesenhoTalhaoProps {
  isOpen: boolean
  update?: number
  onClose: (data: boolean) => void
  cultivavel?: boolean
  talhao: {
    nome: string
    propriedadeCod: number
    propriedadeNome: string
    fitBounds: L.LatLngBoundsExpression | null
    polygon: L.LatLngTuple[] | any[]
  }
  onSuccess?: () => void
  atualizarLista?: Function
}

const DesenhoTalhaoNovoNew: React.FC<DesenhoTalhaoProps> = ({
  isOpen,
  talhao,
  onClose,
  update = 0,
  cultivavel,
  onSuccess,
  atualizarLista,
}) => {
  const [map, setMap] = useState<L.Map | null>(null)
  const [polygonCoords, setPolygonCoords] = useState<L.LatLngTuple[]>([])

  const [visible, setVisible] = useState(false)

  const [getAreaTalhao, setGetAreaTalhao] = useState<number>(0)

  // Undo/Redo stores arrays of LatLngTuples
  const [undoPolygon, setUndoPolygon] = useState<L.LatLngTuple[][]>([])
  const [redoPolygon, setRedoPolygon] = useState<L.LatLngTuple[][]>([])
  const [kinksPoints, setKinksPoints] = useState<L.LatLngTuple[]>([])

  const [salvar, setSalvar] = useState(false)
  const [carregando_salvar, setCarregando_salvar] = useState<boolean>(false)
  const [nome, setNome] = useState<string>('')
  const [area, setArea] = useState<string>('')
  const [codPropriedade, setCodPropriedade] = useState<number>(null)

  const [hoverIndex, setHoverIndex] = useState<number | null>(null)

  const [form] = Form.useForm()
  const { setAtualizarArea, atualizarArea } = useAccess()

  useEffect(() => {
    setVisible(isOpen)
  }, [isOpen])

  const onFinish = async () => {
    try {
      loadingAlert({ msg: 'Salvando...', id: 'cadastro_talhao' })
      setCarregando_salvar(true)

      // Adaptar para KML / Google formato para manter as API funcionando (O sistema usa {lat, lng} pro KML)
      const polygonFinish = polygonCoords.map((coord) => ({
        lat: coord[0],
        lng: coord[1],
      }))

      const kml = geralKmlPolygon(polygonFinish, nome)

      const cripto = btoa(kml)

      const arquivo = `data:@file/xml;base64,${cripto}`

      const dados = {
        nome: nome,
        cod_propriedade: update,
        arquivo: arquivo,
        status: 1,
        area: String(area),
      }

      if (update <= 0) {
        const response = cultivavel
          ? await postTalhaoCultivavel(talhao.propriedadeCod, dados)
          : await postTalhao(talhao.propriedadeCod, dados)
        if (response.status === 201) {
          successAlert('Talhão cadastrado com sucesso!', 5000, 'cadastro_talhao')
          onSuccess?.()
          setAtualizarArea(!atualizarArea)
          atualizarLista?.()
          setSalvar(false)
          setCarregando_salvar(false)
        }
      } else {
        const response = cultivavel
          ? await putTalhaoCultivavel(talhao.propriedadeCod, update, dados)
          : await putTalhao(talhao.propriedadeCod, update, dados)
        if (response.status === 200) {
          successAlert('Talhão atualizado com sucesso!', 5000, 'cadastro_talhao')
          onSuccess?.()
          setAtualizarArea(!atualizarArea)
          atualizarLista?.()
          setSalvar(false)
          setCarregando_salvar(false)
        }
        setCarregando_salvar(false)
      }
    } catch (error) {
      setCarregando_salvar(false)

      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha ao registrar talhão!', 5000, 'cadastro_talhao')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha ao registrar talhão!', 5000, 'cadastro_talhao')
          })
        }
      } else {
        destroyAlert()
      }
    }
  }

  const normalizeLatLng = (data: any[]): L.LatLngTuple[] => {
    if (!data || data.length === 0) return []
    return data.map((pt) => {
      // Se já for array [lat, lng]
      if (Array.isArray(pt)) return [pt[0], pt[1]]
      // Se for objeto API do Google {lat, lng} com funções (ou literais)
      const lat = typeof pt.lat === 'function' ? pt.lat() : pt.lat
      const lng = typeof pt.lng === 'function' ? pt.lng() : pt.lng
      return [lat, lng]
    })
  }

  // Novo calculo de área manual com Turf
  const calculateAreaGeo = (coords: L.LatLngTuple[]) => {
    if (coords.length < 3) return 0
    // O turf area precisa que o anel esteja fechado (primeiro ponto igual o último)
    // E o formato turf de polygon é [lng, lat]
    const ring = coords.map((c) => [c[1], c[0]])
    ring.push([coords[0][1], coords[0][0]]) // fechar anel

    try {
      const poly = turf.polygon([ring])
      const sqMeters = turf.area(poly)
      const ha = sqMeters / 10000
      return parseFloat(ha.toFixed(2))
    } catch {
      return 0
    }
  }

  const handleUpdatePolygonAction = (newCoords: L.LatLngTuple[]) => {
    setPolygonCoords(newCoords)
    const ha = calculateAreaGeo(newCoords)

    setGetAreaTalhao(ha)
    form.setFieldsValue({ area: ha })
    setArea(String(ha))

    setKinksPoints(validateKinks(newCoords))
  }

  const pushUndoState = (newCoords: L.LatLngTuple[]) => {
    setUndoPolygon(prev => [...prev, [...polygonCoords]])
    setRedoPolygon([]) // Limpa o redo quando uma nova ação é tomada na mão
    handleUpdatePolygonAction([...newCoords])
    setSalvar(true)
  }

  const handleUndo = () => {
    if (undoPolygon.length === 0) return
    const historyState = [...undoPolygon]
    const previous = historyState.pop()!

    // Save current to redo queue
    setRedoPolygon(prev => [...prev, [...polygonCoords]])

    setUndoPolygon(historyState)
    handleUpdatePolygonAction(previous)
  }

  const handleRedo = () => {
    if (redoPolygon.length === 0) return
    const historyState = [...redoPolygon]
    const future = historyState.pop()!

    // Save current to undo queue
    setUndoPolygon(prev => [...prev, [...polygonCoords]])

    setRedoPolygon(historyState)
    handleUpdatePolygonAction(future)
  }

  const handleResetDesenho = () => {
    setUndoPolygon([])
    setRedoPolygon([])
    const initialPolygon = normalizeLatLng(talhao.polygon)
    handleUpdatePolygonAction(initialPolygon)
    destroyAlert()
  }

  const validateKinks = (coordinates: L.LatLngTuple[]) => {
    try {
      if (coordinates.length < 4) return []
      const coords = coordinates.map((c) => [c[1], c[0]]) // Leaflet latLng -> Turf lngLat
      coords.push(coords[0])
      const poly = turf.polygon([coords])
      const intersectKinks = turf.kinks(poly)
      if (intersectKinks.features.length > 0) {
        return intersectKinks.features.map(feature => {
          return [feature.geometry.coordinates[1], feature.geometry.coordinates[0]] as L.LatLngTuple
        })
      }
      return []
    } catch {
      return []
    }
  }

  useEffect(() => {
    if (isOpen) {
      if (update > 0) {
        setNome(talhao.nome)

        const leafPolygon = normalizeLatLng(talhao.polygon)
        const ha = calculateAreaGeo(leafPolygon)

        setArea(String(ha))
        setCodPropriedade(talhao.propriedadeCod)
        setPolygonCoords(leafPolygon)
        setKinksPoints(validateKinks(leafPolygon))
      } else {
        form.resetFields()
        setNome('')
        setArea('')
        setPolygonCoords([])
      }
      setUndoPolygon([])
      setRedoPolygon([])
    }
  }, [isOpen, update]) // Independente do objeto 'talhao' referenciar diferente a cada render do pai, ele trava a edição.

  const kinkIcon = L.divIcon({
    className: 'custom-kink-icon',
    html: `
      <div style="filter: drop-shadow(2px 2px 3px rgba(0,0,0,0.5)); transform: translate(-2px, -2px)">
        <svg viewBox="0 0 24 36" width="24" height="36" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.373 2 2 6.373 2 12c0 7.5 10 22 10 22s10-14.5 10-22C22 6.373 17.627 2 12 2z" fill="#ff0000" stroke="#000" stroke-width="2"/>
          <text x="12" y="16" fill="white" font-size="15" font-family="Arial, sans-serif" font-weight="bold" text-anchor="middle" dominant-baseline="middle">!</text>
        </svg>
      </div>`,
    iconSize: [24, 36],
    iconAnchor: [12, 34],
    popupAnchor: [0, -34]
  })

  const polygonRef = React.useRef<L.Polygon>(null)

  // ==========================================
  // LÓGICA DE EDIÇÃO VERTICAL MANUAl (Puxar vertices)
  // ==========================================
  const handleVertexDrag = (index: number, newPos: L.LatLngTuple) => {
    const updated = [...polygonCoords]
    updated[index] = newPos
    pushUndoState(updated)
  }

  const handleVertexRightClick = (index: number, e: L.LeafletMouseEvent) => {
    L.DomEvent.preventDefault(e.originalEvent) // BLOQUEIA O MENU DIREITO NATIVO DA TELA
    L.DomEvent.stopPropagation(e.originalEvent)

    if (polygonCoords.length <= 3) {
      errorAlert('Não é possível ter menos de 3 vértices no talhão.', 5000, 'vertex_error')
      return
    }
    const updated = [...polygonCoords]
    updated.splice(index, 1)
    pushUndoState(updated)
  }

  const handleEdgeDragCreate = (indexA: number, indexB: number, newPos: L.LatLngTuple) => {
    const updated = [...polygonCoords]
    updated.splice(indexB, 0, newPos)
    pushUndoState(updated)
  }

  // Custom Leaflet Icons for Points -> Emulating Google Maps Dots
  const vertexIcon = L.divIcon({
    className: 'custom-vertex-icon',
    html: `<div style="width:12px; height:12px; background:white; border:2px solid ${kinksPoints.length > 0 ? '#ff4d4f' : 'cyan'}; border-radius:50%; box-shadow: 0 0 2px rgba(0,0,0,0.5);"></div>`,
    iconSize: [12, 12],
    iconAnchor: [6, 6]
  })

  // Meio da linha invisíveis/fantasmas (para dar pra puxar livremente)
  const edgeIcon = L.divIcon({
    className: 'custom-edge-icon',
    html: `<div style="width:10px; height:10px; background:rgba(255,255,255,0.7); border:1px solid ${kinksPoints.length > 0 ? '#ff4d4f' : 'cyan'}; border-radius:50%;"></div>`,
    iconSize: [10, 10],
    iconAnchor: [5, 5]
  })


  return (
    <Container>
      <Drawer
        open={visible}
        closeIcon={false}
        headerStyle={{ display: 'none' }}
        bodyStyle={{ padding: 0 }}
        onClose={() => onClose(false)}
        style={{ position: 'absolute' }}
        placement='bottom'
        height='100%'
      >
        <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
          <MapContainer
            style={{ width: '100%', height: '100%', zIndex: 1 }}
            zoom={15}
            center={[-15, -50]} // O MapContainer não lida bem com ref dinamico de arrays sem renderizar forçado
            maxZoom={30} // Zoom infinito liberado localmente
          >
            <TileLayer
              url='http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'
              maxNativeZoom={20} // Onde a foto termina, ele inicia o upscale local!
              maxZoom={30}
              subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            />

            <ZoomToPolygonBounds key={`zoom-${update}`} coords={polygonCoords} />

            {/* RENDER POLÍGONO BASE */}
            {polygonCoords.length > 0 && (
              <Polygon
                ref={polygonRef}
                positions={polygonCoords}
                pathOptions={{
                  color: kinksPoints.length > 0 ? '#ff4d4f' : 'cyan', // Google Maps tem o line color default em vermelho tambem
                  fillColor: kinksPoints.length > 0 ? '#ff4d4f' : 'cyan',
                  weight: 3,
                  fillOpacity: 0.35
                }}
              />
            )}

            {/* RENDER EDITORES (NÓS) DO POLÍGONO */}
            {polygonCoords.map((coord, i) => (
              <React.Fragment key={`frag_vertex_${i}`}>
                {/* Vértice Real do Polígono */}
                <Marker
                  position={coord}
                  icon={vertexIcon}
                  draggable={true}
                  eventHandlers={{
                    drag: (e: any) => {
                      if (polygonRef.current) {
                        const position = e.target.getLatLng()
                        const newCoords = [...polygonCoords]
                        newCoords[i] = [position.lat, position.lng]
                        polygonRef.current.setLatLngs(newCoords)
                      }
                    },
                    dragend: (e) => {
                      const marker = e.target
                      const position = marker.getLatLng()
                      handleVertexDrag(i, [position.lat, position.lng])
                    },
                    contextmenu: (e) => handleVertexRightClick(i, e) // Clique direito para excluir
                  }}
                />

                {/* Meio da Linha (Fantasma) p/ Criar novos pontos */}
                {(() => {
                  const nextIndex = i === polygonCoords.length - 1 ? 0 : i + 1;
                  const nextCoord = polygonCoords[nextIndex];

                  const edgeCenter: L.LatLngTuple = [
                    (coord[0] + nextCoord[0]) / 2,
                    (coord[1] + nextCoord[1]) / 2
                  ]

                  return (
                    <Marker
                      position={edgeCenter}
                      icon={edgeIcon}
                      draggable={true}
                      eventHandlers={{
                        dragstart: (e: any) => {
                           if (polygonRef.current) {
                             const position = e.target.getLatLng()
                             const newCoords = [...polygonCoords]
                             newCoords.splice(nextIndex, 0, [position.lat, position.lng])
                             polygonRef.current.setLatLngs(newCoords)
                           }
                        },
                        drag: (e: any) => {
                           if (polygonRef.current) {
                             const position = e.target.getLatLng()
                             const newCoords = [...polygonCoords]
                             newCoords.splice(nextIndex, 0, [position.lat, position.lng])
                             polygonRef.current.setLatLngs(newCoords)
                           }
                        },
                        dragend: (e) => {
                          const marker = e.target
                          const position = marker.getLatLng()
                          handleEdgeDragCreate(i, nextIndex, [position.lat, position.lng])
                        }
                      }}
                    />
                  )
                })()}

              </React.Fragment>
            ))}

            {kinksPoints.map((point, index) => (
              <Marker
                key={`kink_${index}`}
                position={point}
                icon={kinkIcon}
                interactive={false} // Click-through so it doesn't block the polygon underneath
              />
            ))}

            <CardDados style={{ zIndex: 1000, pointerEvents: 'auto' }}>
              <div style={{ display: 'flex', marginTop: '10px' }}>
                <ButtonCustom
                  onClick={() => onClose(false)}
                  type='tertiary'
                  danger
                  icon={<FontAwesomeIcon icon={faXmark} />}
                >
                  Fechar
                </ButtonCustom>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  boxSizing: 'border-box',
                  padding: '15px',
                  gap: '10px',
                }}
              >
                <TitleH3>Dados talhão</TitleH3>
                <Input
                  label='Nome'
                  placeholder='Digite o nome do talhão'
                  value={nome}
                  onChange={setNome}
                />
                <Input
                  label='Área(ha)'
                  placeholder='Digite a área do talhão'
                  value={area}
                  onChange={setArea}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <ButtonCustom
                      disabled={undoPolygon.length <= 1}
                      onClick={handleUndo}
                      style={{ color: 'white' }}
                      title='Desfazer'
                      icon={<FontAwesomeIcon icon={faUndo} />}
                    />
                    <ButtonCustom
                      disabled={redoPolygon.length <= 0}
                      onClick={handleRedo}
                      style={{ color: 'white' }}
                      title='Refazer'
                      icon={<FontAwesomeIcon icon={faRedo} />}
                    />
                    <ButtonCustom
                      onClick={handleResetDesenho}
                      style={{ color: 'white' }}
                      type='primary'
                      danger
                      title='Resetar'
                      icon={<FontAwesomeIcon icon={faSync} />}
                    />
                  </div>
                  {kinksPoints.length > 0 ? (
                    <ButtonCustom icon={<FontAwesomeIcon icon={faFloppyDisk} />} type="primary" danger disabled onClick={() => { }}>
                      Salvar correção
                    </ButtonCustom>
                  ) : (
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                      onClick={onFinish}
                      loading={carregando_salvar}
                    >
                      {update > 0 ? 'Atualizar talhão' : 'Gerar talhão'}
                    </ButtonCustom>
                  )}
                </div>
              </div>
            </CardDados>
          </MapContainer>
        </div>
      </Drawer>
    </Container>
  )
}

export default DesenhoTalhaoNovoNew